module.exports = __webpack_public_path__ + "assets/img/05.remote-debug.d940372f.png";